import ProfileCircleIcon from "@/components/icons/ProfileCircleIcon";
import BurgerMenuIcon from "@/components/icons/BurgerMenu";
// import SearchIcon from "@/components/icons/SearchIcon";
import CartIcon from "@/components/icons/CartIcon";
// import MegaMenu from "./mega-menu/MegaMenu";
import Search from "@/layout/header/Search";
import Logo from "@/components/icons/Logo";
import Link from "next/link";

import { useCart } from "@/context/cart";
import { ModalContext } from "@/pages/_app";
import { useContext, useEffect, useRef, useState } from "react";
import { useWishlist } from "@/context/wishlist";
import { useSession } from "next-auth/react";
import { calcCartTotalHandler } from "@/helpers/cart";
import NavHeartIcon from "@/components/icons/NavHeartIcon";
import OfferEndDate from "./offer-end-date/OfferEndDate";
import { useClient } from "@/hooks/useClient";
import useHandleOutside from "@/hooks/useHandleOutside";
import CartDropDown from "./cart-drop-down/CartDropDown";
import CurrencyIcon from "@/components/icons/CurrencyIcon";
// import Image from "@/components/global/Image";

const Navbar = ({ locale, push, headerJson }) => {
  const { isClient } = useClient();
  const [cartDropDown, setCartDropDown] = useState(false);
  const refCart = useRef();

  useHandleOutside(refCart, () => setCartDropDown(false));

  const Context = useContext(ModalContext);
  const {
    cart: { cartItems },
  } = useCart();

  const [cartItemsState, setCartItemsState] = useState();
  const [wishlistState, setWishlistState] = useState();
  const { wishlist } = useWishlist();
  const wishlistCount = Object.keys(wishlist || {})?.length;
  const { data: session } = useSession();
  useEffect(() => {
    setCartItemsState(cartItems);
    setWishlistState(wishlistCount);
  }, [cartItems, wishlistCount]);

  const cartTotal = calcCartTotalHandler(cartItems || []);

  return (
    <nav className="bg-white">
      <div className="flex items-center justify-between w-11/12 gap-4 mx-auto sm:py-4 sm:gap-7">
        <Link
          prefetch={false}
          href="/"
          className="max-md:w-[55px] aspect-video relative overflow-hidden w-[150px]"
        >
          <Logo className="size-full sm:w-auto sm:h-auto" />
        </Link>
        <Search />
        {/* <Offers locale={locale} className="hidden md:flex" /> */}
        {/* offer in desktop view */}
        <div className="hidden sm:block w-fit">
          <OfferEndDate headerJson={headerJson} />
        </div>

        <div className="flex items-center gap-7 text-secondary-800">
          <button
            onClick={() => {
              if (!session?.user) {
                Context?.dispatch({ type: "auth" });
              } else {
                push("/user");
              }
            }}
            className="items-center hidden gap-3 lg:flex"
          >
            <ProfileCircleIcon />
            <span className="flex flex-col items-start text-black">
              <span className="font-bold">
                {!session?.user
                  ? locale === "en"
                    ? "My Account"
                    : "الحساب"
                  : locale === "en"
                  ? "Welcome"
                  : "مرحبا"}
              </span>
              <span className="text-sm font-semibold">
                {!session?.user
                  ? locale === "en"
                    ? "Login / Register"
                    : "تسجيل / إشتراك"
                  : (session?.user.firstname || " ") +
                    " " +
                    (session?.user.lastname || "")}
              </span>
            </span>
          </button>
          <div className="relative hidden cursor-pointer lg:block">
            <Link prefetch={false} href="/user/favourite">
              <NavHeartIcon />
            </Link>
            {wishlistState ? (
              <div className="absolute -top-2.5 -right-2.5 size-5 bg-primary-800 text-white rounded-full flex items-center justify-center text-sm">
                {wishlistState}
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            onClick={() => {
              setCartDropDown((prev) => !prev);
            }}
            className={`items-center hidden relative cursor-pointer ${
              cartItemsState?.length ? "gap-5" : "gap-3"
            } lg:flex`}
          >
            <div className="relative cursor-pointer">
              <CartIcon />
              {cartItemsState?.length ? (
                <span className="absolute -top-2.5 -right-2.5 size-5 bg-primary-800 text-white rounded-full flex items-center justify-center text-sm">
                  {cartItemsState?.length}
                </span>
              ) : (
                ""
              )}
            </div>
            <span className="flex flex-col items-start text-black">
              <span className="font-bold">
                {locale === "en" ? "My Cart" : "عربة التسوق"}
              </span>
              {isClient && (
                <span className="flex items-center gap-1 text-sm font-semibold">
                  {cartTotal} <CurrencyIcon className="size-3.5" />
                </span>
              )}
            </span>
            {cartDropDown && (
              <CartDropDown
                onHide={() => setCartDropDown(false)}
                ref={refCart}
                items={cartItems}
                cartTotal={cartTotal ? cartTotal.toFixed(2) : 0}
              />
            )}
          </div>
          <button
            aria-label="Burger Menu"
            onClick={() => Context?.dispatch({ type: "sidemenu" })}
          >
            <BurgerMenuIcon />
          </button>
        </div>
      </div>

      {/* offer in mob view */}
      <div className="block pb-0 mt-2 sm:hidden">
        <OfferEndDate headerJson={headerJson} />
        {/* <Offers
          locale={locale}
          className="justify-center w-10/12 mx-auto mt-2"
        /> */}
      </div>
    </nav>
  );
};

export default Navbar;

// const Offers = ({ locale, className }) => {
//   return (
//     <div
//       className={`flex justify-center items-center gap-4  ${className || ""}`}
//     >
//       {/* <div
//         onClick={() => copyToClipboard("FD15", locale)}
//         className="font-bold min-w-32 hover:text-gray-800 text-[#6b4e45] flex gap-2 justify-center items-center text-[10px] text-nowrap md:text-xs "
//       >
//         <Image
//           src="/imgs/national-day.png"
//           width={40}
//           height={40}
//           className="object-contain size-8 md:size-10 bg-blend-multiply"
//           alt=""
//         />
//         <p className="flex flex-col gap-1">
//           <span>
//             {locale === "ar"
//               ? "يوم التأسيس، الضريبة علينا "
//               : "Foundation Day, VAT on us."}
//           </span>
//           <span className="cursor-pointer animate-pulse ">{locale === "ar" ? "استخدم FD15" : "Use FD15"}</span>
//         </p>
//       </div> */}
//       <a
//         className="font-bold min-w-32 hover:text-gray-800 text-[#77458f] flex gap-2 justify-center items-center text-[10px] text-nowrap md:text-xs "
//         href="https://imgs.awahed.com/media/media/Ramadan-flyer2025.pdf"
//         target="_blank"
//       >
//         <Image
//           src="/imgs/helal.gif"
//           width={40}
//           height={40}
//           className="object-contain size-8 md:size-10 bg-blend-multiply"
//           alt=""
//         />
//         {locale === "ar" ? "تصفح\n عروض رمضان" : "Browse\n Ramadan offers"}
//       </a>
//     </div>
//   );
// };
